import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon, SelectorIcon } from '@heroicons/react/outline'
import { ConfirmModal } from 'components/confirmModal'
import { CURRENCY_LIST } from 'utills/constants'

export const CurrencyButton = () => {
  const currency = localStorage.getItem("currency");

  const [isOpenCurrencyModal, setIsOpenCurrencyModal] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(currency)

  const _updateCurrency = () => {
    if (selectedCurrency === currency) {
      setIsOpenCurrencyModal(false);
      return;
    }

    localStorage.setItem("currency", selectedCurrency ?? "");
    window.location.reload();
  }

  const _openCurrencyModal = () => {
    setIsOpenCurrencyModal(true);
    setSelectedCurrency(currency);
  }

  const currencyData = CURRENCY_LIST.find(currency => currency.code === selectedCurrency);
  return (
    <div>
      <button
        type="button"
        className="inline-flex items-center gap-x-2 rounded-md bg-magnolia-500 ring-magnolia-500 text-brand-500 px-3 py-2 text-sm font-semibold shadow-sm hover:bg-magnolia-600 active:opacity-85"
        onClick={_openCurrencyModal}
      >
        {currency}
        <ChevronDownIcon aria-hidden="true" className="size-4" />
      </button>
      <ConfirmModal 
        key="currency-modal"
        title="Currencies"
        content="All available tickets will be deleted when you change the event type."
        customContent={(
          <div className='mt-4 mb-8 text-left'>
            <p className='text-sm'>The currency exchange rate on ActiUp is only approximate</p>
            <Listbox value={selectedCurrency} onChange={setSelectedCurrency}>
              <div className="relative mt-4">
                <Listbox.Button className="relative w-full rounded-lg bg-white py-2.5 pl-3 pr-10 text-left border border-solid border-gray-300 shadow-sm focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                  {currencyData ? (
                    <span className="block truncate">
                      {currencyData?.code} - {currencyData?.name} ({currencyData?.symbol})
                    </span>
                  ) : <></>}
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <SelectorIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <Transition
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute mt-1 z-10 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                    {CURRENCY_LIST.filter(currency => currency.code === "VND" || currency.code === "USD").map((currency, index) => (
                      <Listbox.Option
                        key={index}
                        className={({ active }) =>
                          `relative cursor-default select-none py-2 pl-10 pr-4 ${
                            active ? 'bg-magnolia-500 text-brand-500' : 'text-black'
                          }`
                        }
                        value={currency.code}
                      >
                        {({ selected }) => (
                          <>
                            <span
                              className={`block truncate ${
                                selected ? 'font-medium text-brand-500' : 'font-normal'
                              }`}
                            >
                              {currency.code} - {currency.name} ({currency.symbol})
                            </span>
                            {selected ? (
                              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-brand-500">
                                <CheckIcon className="size-5" aria-hidden="true" />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </Listbox>
          </div>
        )}
        hideCancelButton={true}
        open={isOpenCurrencyModal}
        onConfirm={() => _updateCurrency()}
        onClose={() => setIsOpenCurrencyModal(false)}
      />
    </div>
  )
}
